import { Dialog, DialogProps } from 'primereact/dialog'
import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button } from '../Button/Button'

interface IConfirmationModal extends Omit<DialogProps, 'onHide'> {
  onSubmit: () => void | Promise<void>
  title: string
  text: string
  onHide?: () => void
  confirmButtonLabel?: string
  isLoading?: boolean
}

export const ConfirmationModal: FC<IConfirmationModal> = ({
  title,
  text,
  confirmButtonLabel = 'Confirm',
  onSubmit,
  onHide,
  children,
  isLoading,
  ...props
}) => {
  const [visible, setVisible] = useState(false)

  const onCancel = () => {
    onHide && onHide()
    setVisible(false)
  }

  const handleClick = async () => {
    await onSubmit()
    setVisible(false)
  }

  const renderFooter = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" size="large" onClick={onCancel} variant="ghost">
          Cancel
        </Button>
        <Button isLoading={isLoading} type="submit" size="large" onClick={handleClick}>
          {confirmButtonLabel}
        </Button>
      </div>
    )
  }

  useEffect(() => {
    if (props.visible) setVisible(props.visible)
  }, [props.visible])

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation()
          setVisible(true)
        }}
      >
        {children}
      </div>
      <StyledDialog
        {...props}
        breakpoints={{ '768px': '75vw' }}
        visible={visible}
        footer={renderFooter}
        onHide={onCancel}
      >
        <div className="mb-3">
          <div className="modal-title">{title}</div>
          <div className="modal-description">{text}</div>
        </div>
      </StyledDialog>
    </>
  )
}

const StyledDialog = styled(Dialog)`
  max-width: 600px;
  margin-inline: 1rem;

  @media (min-width: 768px) {
    max-width: 600px;
    min-width: 400px;
  }

  .modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 1rem;
  }

  .p-button-text {
    color: ${({ theme }) => theme.colors.black};
    font-weight: 600;
    font-size: 1.125rem;
  }

  button {
    color: ${({ theme }) => theme.colors.black};
    font-weight: 600;
    font-size: 1.125rem;
  }
`
